import React, { useState, useEffect, useCallback } from 'react';
import { PackageCheck, Pencil, Ban, Image as ImageIcon } from 'lucide-react';
import { api, API, inr, timeAgo } from '../api';
import { toast } from 'sonner';

export default function AdminBulkOrders() {
  const [orders, setOrders] = useState([]);
  const load = useCallback(() => api.get('/bulk-orders').then((r) => setOrders(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const editAmount = async (o) => {
    const val = window.prompt(`New amount for ${o.customer_name}'s bulk order (₹):`, o.total);
    if (val === null) return;
    const amt = Number(val);
    if (!amt || amt <= 0) return toast.error('Enter a valid amount');
    await api.put(`/admin/orders/${o.id}`, { amount: amt });
    toast.success(`Bulk order updated to ${inr(amt)}`);
    load();
  };

  const cancel = async (o) => {
    if (!window.confirm(`Cancel ${o.customer_name}'s bulk order of ${inr(o.total)}? ${o.created_by_name}'s sales credit will be removed.`)) return;
    await api.delete(`/admin/orders/${o.id}`);
    toast.success('Bulk order cancelled');
    load();
  };

  if (orders.length === 0) return null;

  return (
    <div data-testid="admin-bulk-orders">
      <div className="flex items-baseline gap-3 mb-3 flex-wrap">
        <h3 className="font-display font-bold text-lg text-slate-800 flex items-center gap-2"><PackageCheck size={17} className="text-fuchsia-600" /> Bulk Orders</h3>
        <p className="font-hand text-base text-slate-400">screenshot-backed orders added by agents · counted in their targets</p>
      </div>
      <div className="bg-white border-2 border-slate-200 rounded-xl sticky-shadow overflow-hidden">
        {orders.map((o) => (
          <div key={o.id} data-testid={`bulk-order-row-${o.id}`} className="flex items-center gap-3 px-3 py-2.5 border-b border-slate-50 flex-wrap">
            <div className="min-w-0 flex-1">
              <p className="text-xs font-bold text-slate-900 truncate">{o.customer_name}
                <span className="ml-2 font-medium text-slate-400">{o.mobile_number}</span>
              </p>
              <p className="text-[10px] text-slate-400">by <b className="text-slate-600">{o.created_by_name}</b> · {timeAgo(o.created_at)}</p>
            </div>
            <span className="shrink-0 font-display font-extrabold text-sm text-slate-900">{inr(o.total)}</span>
            {o.screenshot_path ? (
              <a data-testid={`bulk-order-screenshot-${o.id}`} href={`${API}/files/${o.screenshot_path}`} target="_blank" rel="noreferrer"
                className="shrink-0 flex items-center gap-1 text-[10px] font-bold text-sky-600 hover:underline"><ImageIcon size={12} /> Screenshot</a>
            ) : (
              <span className="shrink-0 text-[10px] font-semibold text-slate-300">no screenshot</span>
            )}
            <button data-testid={`bulk-order-edit-${o.id}`} onClick={() => editAmount(o)} title="Modify amount"
              className="shrink-0 p-1 rounded-lg text-slate-400 hover:text-blue-600 hover:bg-blue-50"><Pencil size={13} /></button>
            <button data-testid={`bulk-order-cancel-${o.id}`} onClick={() => cancel(o)} title="Cancel order (removes sales credit)"
              className="shrink-0 p-1 rounded-lg text-slate-300 hover:text-red-600 hover:bg-red-50"><Ban size={13} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
